import React from "react";
import firebase from "../firebase/firebase";

export const searchFriends = (search, cuser, cmpState) => {
  console.log("dao search friends", search);
  const fs = firebase.firestore();
  const user = fs.collection("users");
  let searchlist = [];
  user
    .where("FullName", ">=", search)
    //.where("FullName", "<=", search + "~")
    .orderBy("FullName")
    .get()
    .then((doc) => {
      doc.forEach((d) => {
        console.log("get friends", d.data());
        let fuser = d.id;
        if (fuser !== cuser) {
          searchlist.push({ userid: d.id, ...d.data() });
        }
      });
      cmpState.handleState("search", searchlist);
    })
    .catch((error) => {
      cmpState.handleState("search", []);
    });
};

export const getMessages = (uid, cmpState) => {
  console.log("dao get message");
  const fs = firebase.firestore();
  let posts = [];

  fs.collection("Posts")
    .doc(uid.toLowerCase())
    .collection("Messages")
    .get()
    .then((doc) => {
      doc.forEach((d) => {
        posts.push({ userid: uid, keyid: d.id, ...d.data() });
      });

      if (posts.length === 0) {
        cmpState.handleState("messages", []);
        cmpState.handleState("loading", false);
      } else {
        cmpState.handleState("messages", posts);
        cmpState.handleState("loading", false);
        console.log("mainCtrl messages", posts);
      }
    })
    .catch((error) => {
      cmpState.handleState("error", true);
      cmpState.handleState(
        "errorMsg",
        "unable to pull posts from server, due to connection error"
      );
      cmpState.handleState("loading", false);
    });
};

export const updateLikes = (keyid, userid, nLikes) => {
  const fs = firebase.firestore();
  const posts = fs.collection("Posts").doc(userid.toLowerCase());
  const msg = posts
    .collection("Messages")
    .doc(keyid)
    .update({ likes: nLikes })
    .then(() => {
      console.log("successfully updated likes ");
    })
    .catch((error) => {
      console.log("error on like", error);
    });
};

export const deletePost = (keyid, userid, cmpState) => {
  const fs = firebase.firestore();
  const posts = fs.collection("Posts").doc(userid.toLowerCase());

  const msg = posts
    .collection("Messages")
    .doc(keyid)
    .delete()
    .then(() => {
      console.log("successfully deleted post ");
      const items = cmpState.state.messages; //this.state.messages;
      const index = items.findIndex(
        (item, i) => item.keyid === keyid && item.userid === userid
      );
      delete items[index];
      cmpState.handleState("messages", items);
    })
    .catch((error) => {
      console.log("error on delete", error);
    });
};

export const createPost = (userid, messages, cmpState) => {
  // this.setState({
  //   btnPostDisable: true,
  // });

  // cmpState.handleState({ btnPostDisable: true });
  // if (cmpState.state.newPost.trim() === "") {
  //   let val = cmpState.state.newPost.trim();
  //   cmpState.handleState({ newPost: val });

  // this.setState({
  //   newPost: val,
  // });
  //   return;
  // }

  const dt = new firebase.firestore.Timestamp.fromDate(new Date());
  const newPost = {
    message: cmpState.state.newPost, //this.state.newPost,
    likes: 0,
    datecreated: dt,
  };

  const fs = firebase.firestore();
  const uid = userid.toLowerCase(); //this.props.appProps.state.userid;
  const posts = fs.collection("Posts").doc(uid);
  const msg = posts.collection("Messages");
  const id = "";
  // return msg
  //   .add({ id })
  //   .then((doc) => {
  //     msg.doc(doc.id).set(newPost);
  // .then(() => {
  //   return { docid: doc.id, ...newPost };
  // })
  // .catch((error) => {
  //   return { error: error };
  // });
  // })
  // .catch((error) => {});
  msg
    .add({ id })
    .then((doc) => {
      msg
        .doc(doc.id)
        .set(newPost)
        .then(() => {
          console.log("added a new post ", doc.id);
          let items = messages.state.messages; //this.props.mainCtrlProps.state.messages;
          items.push({ userid: uid, keyid: doc.id, ...newPost });
          cmpState.handleState({ newPost: "", btnPostDisable: false });
          //this.setState({ newPost: "", btnPostDisable: false });
          messages.handleState("messages", items);
          //this.props.mainCtrlProps.handleState("messages", items);
        })
        .catch((error) => {
          console.log("error on creating post for doc id", error);
          cmpState.handleState({ btnPostDisable: false });
          //this.setState({ btnPostDisable: false });
        });
    })
    .catch((error) => {
      console.log("error in creating post", error);
      cmpState.handleState({ btnPostDisable: false });
      //this.setState({ btnPostDisable: false });
    });
};

export const isfollowing = (cuser, fuser) => {
  console.log("check following friend", cuser, fuser);

  const dt = new firebase.firestore.Timestamp.fromDate(new Date());
  const fs = firebase.firestore();
  const user = fs.collection("users").doc(cuser.toLowerCase());
  const following = user.collection("following");
  return following.doc(fuser.toLowerCase()).get();
};

export const countfollow = (userid, type, callback) => {
  console.log("count follower & following for user ", userid);

  const dt = new firebase.firestore.Timestamp.fromDate(new Date());
  const fs = firebase.firestore();
  const user = fs.collection("users").doc(userid.toLowerCase());
  const follow = user.collection(type);
  follow.get().then((doc) => {
    callback({ total: doc.size });
  });
};
